import Vue from '../../lib/utils/vue'
import { styled, VueEmotion } from '@egoist/vue-emotion'
import * as getters from '../../../builder/src/js/store/modules/getters'
import { mapGetters, mapState } from '../../../builder/node_modules/vuex'
import CvtSiteStatusLabel from '../molecules/SiteStatusLabel'
import CvtButton from '../molecules/Button'
import VueI18n from 'vue-i18n'


Vue.use(VueEmotion)
Vue.use(VueI18n)


let Spacing, FontSize, Radii, Border, Colors, textLineHeight, BorderStyle, textFontWeight, borderColor, backgroundColor, textFontSize, textColor, LineHeight;


const getContainer = () => styled('div')`
  height: ${Spacing.SPACING_64 + Spacing.SPACING_8}px;
  ${backgroundColor({ themeing: 'dark' }, 'WHITE')}
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-top-width: 0px;
  border-bottom-width: ${Border.SIZE_1}px;
  border-style: ${BorderStyle.SOLID};
  ${borderColor({ themeing: 'dark' }, 100)};
`


const getInnerContainer = () => styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`


const getLabelContainer = () => styled('div')`
  width: ${(2*Spacing.SPACING_256) + Spacing.SPACING_128}px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`


const getButtonsContainer = () => styled('div')`
  display: flex;
  width: ${Spacing.SPACING_256+Spacing.SPACING_192 + Spacing.SPACING_2}px;
  justify-content: start;
  align-items: center;
`


const getTemplateTitle = () => styled('div')`
  width: ${(3*Spacing.SPACING_128) + (2*Spacing.SPACING_18) + Spacing.SPACING_2}px ;
  margin: 
    ${Spacing.SPACING_24}px 
    ${Spacing.SPACING_24 + Spacing.SPACING_4}px 
    ${Spacing.SPACING_24}px 
    ${Spacing.SPACING_24}px;
  font-size: ${FontSize.FONT_SIZE_14}px;
  ${textFontWeight('BOLD')}; 
`


const getSiteStatusLabel = () => styled(CvtSiteStatusLabel)`
  line-height: ${LineHeight.LINE_HEIGHT_24 + Spacing.SPACING_2}px !important;
  // margin-right: ${Spacing.SPACING_64}px;
`


const getCopyTemplateButton = () => styled(CvtButton)`
  margin: ${Spacing.SPACING_18 + Spacing.SPACING_2}px ${Spacing.SPACING_8 + Spacing.SPACING_2}px;
`


const getEditTemplateButton = () => styled(CvtButton)`
  margin: ${Spacing.SPACING_18 + Spacing.SPACING_2}px ${Spacing.SPACING_8 + Spacing.SPACING_2}px;
`


const getArchiveButton = () => styled(CvtButton)`
  margin: ${Spacing.SPACING_18 + Spacing.SPACING_2}px ${Spacing.SPACING_8 + Spacing.SPACING_2}px;
`


const getActionsButton = () => styled(CvtButton)`
  text-align: center;
  font-style: normal;
  margin-left: ${Spacing.SPACING_4}px;
`


export const CvtMarketplaceListItem = {
  name: 'CvtMarketplaceListItem',
  data () {
    return {}
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
      required: false
    },
    templateTitle: {
      type: String,
      required: true,
    },
    siteStatus: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('globalTheme', {
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      textColor: getters.GLOBAL_STYLE_COLOR,
      borderColor: getters.GLOBAL_STYLE_BORDER_COLOR,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textLineHeight: getters.GLOBAL_STYLE_LINE_HEIGHT,
    }),

    ...mapState('globalTheme', {
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      Radii: ({ globalTheme }) => globalTheme.Radii,
      Border: ({ globalTheme }) => globalTheme.Border,
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontFamily: ({ globalTheme }) => globalTheme.FontFamily,
      FontWeight: ({ globalTheme }) => globalTheme.FontWeight,
      BorderStyle: ({ globalTheme }) => globalTheme.BorderStyle,
      LineHeight: ({ globalTheme }) => globalTheme.LineHeight,
      FontSize: ({globalTheme}) => globalTheme.FontSize
    })
  },
  created () {
    Spacing = this.Spacing
    Radii = this.Radii
    Border = this.Border
    Colors = this.Colors
    BorderStyle = this.BorderStyle
    LineHeight = this.LineHeight
    FontSize = this.FontSize

    textFontWeight = this.textFontWeight
    borderColor = this.borderColor
    textColor = this.textColor
    backgroundColor = this.backgroundColor
    textFontSize = this.textFontSize
    textLineHeight = this.textLineHeight
  },
  methods: { 
    copyTemplateBtnClicked(event){
      this.$emit('copyTemplateBtnClicked', event);
    },
    
    editSiteBtnClicked(event){
      this.$emit('editSiteBtnClicked', event);
    },
    
    archiveTemplateBtnClicked(event){
      this.$emit('archiveTemplateBtnClicked', event);
    },

    templateActionsBtnClicked(event){
      this.$emit('templateActionsBtnClicked', event);
    },
  },
  render: function (h) {

    const Container = getContainer();
    const InnerContainer = getInnerContainer();
    const TemplateTitle = getTemplateTitle();
    const LabelContainer = getLabelContainer();
    const ButtonContainer = getButtonsContainer();
    const SiteStatusLabel = getSiteStatusLabel();
    const CopyTemplateButton = getCopyTemplateButton();
    const EditTemplateButton = getEditTemplateButton();
    const ArchiveButton = getArchiveButton();
    const ActionsButton = getActionsButton();

    return (
      <Container>

        <InnerContainer>
        
          <LabelContainer>

            <TemplateTitle>
              {this.templateTitle}
            </TemplateTitle>

            <SiteStatusLabel
              status={this.siteStatus}
            >
            </SiteStatusLabel>

          </LabelContainer>

          <ButtonContainer> 
            <CopyTemplateButton
              mode={this.mode}
              text={this.$t('marketplace.templates.label.copyTemplate')}
              icon={'clone'}
              size={'xs'}
              specialPadding={`${Spacing.SPACING_4 + Spacing.SPACING_2}px ${Spacing.SPACING_16}px`}
              prepend={true}
              onClick={(event)=> this.copyTemplateBtnClicked(event)}
            ></CopyTemplateButton> 

            <EditTemplateButton 
              text={this.$t('marketplace.templates.label.editTemplate')}
              mode={this.mode.toLowerCase()}
              color={this.mode.toLowerCase()}
              icon={'pencil'}
              size={'xs'}
              specialPadding={`${Spacing.SPACING_8}px ${Spacing.SPACING_16}px`}
              actionIcon={false}
              icononly={false}
              prepend={true}
              outlined={true}
              onClick={(event)=> this.editSiteBtnClicked(event)}
            ></EditTemplateButton>

            <ArchiveButton
              text={this.$t('marketplace.templates.archive.label')}
              mode={this.mode.toLowerCase()}
              color={this.mode.toLowerCase()}
              icon={'archive'}
              size={'xs'}
              specialPadding={`${Spacing.SPACING_8}px ${Spacing.SPACING_16}px`}
              actionIcon={false}
              icononly={false}
              prepend={true}
              outlined={true}
              onClick={(event)=> this.archiveTemplateBtnClicked(event)}
            ></ArchiveButton>

            <ActionsButton
              mode={this.mode.toLowerCase()}
              color={this.mode.toLowerCase()}
              shape={'pill'}
              size={'md'}
              icon={'ellipsis-h'}
              icononly={true}
              onClick={(event) => this.templateActionsBtnClicked(event)}
            ></ActionsButton>

          </ButtonContainer>
        </InnerContainer>

      </Container>
    )
  }
}
